// extracted by mini-css-extract-plugin
module.exports = {"option":"_1tGQC","title":"BCvtx"};